(function() {

    'use strict';

    eclipseApp.directive('rgAgreement', function() {
        return {
            restrict: 'EA',
            scope: true,
            replace: true,
            templateUrl: 'modules/core/views/agreement.html',
            controller: [function() {
                $("#textAreaContainer").scroll(function() {
                    var acceptBtn = document.getElementById("acceptCheckbox");
                    var declineBtn = document.getElementById("declineRadioButton");
                    if (acceptBtn.disabled === true) {
                        var textArea = document.getElementById("textAreaContainer");
                        acceptBtn.disabled = !(textArea.scrollHeight <= (Math
                            .abs(textArea.scrollTop + 10) + textArea.clientHeight));
                    }
                });
                $(document).ready(function() {
                    $("#checkboxContainer input").click(function() {

                        checkAgreementAcceptance();
                    });
                });

                function checkAgreementAcceptance() {
                    if ("Accept" == $('#checkboxContainer input:checked').val()) {
                        $('.continue').removeAttr('disabled');
                        return true;
                    } else {
                        $('.continue').prop('disabled', true);
                        return false;
                    }
                };



            }]
        };
    });

})();
